module.exports = __webpack_public_path__ + "img/403.257aa840.png";